module.exports = __webpack_public_path__ + "img/Excalibur_Games.c1bca02d.jpg";